// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__6J18c","buttons":"PendingPaymentAlert_buttons__2IDaP"};